// extracted by mini-css-extract-plugin
export var alertIcon = "_om-0";